/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Externally hosted Matterport virtual tour.
 */
export type PropertyExternalMediaMatterportVirtualTourInput = {
    /**
     * Virtual-tour media kind.
     */
    kind: PropertyExternalMediaMatterportVirtualTourInput.kind;
    /**
     * Matterport hosting provider.
     */
    provider: PropertyExternalMediaMatterportVirtualTourInput.provider;
    /**
     * Public HTTP(S) URL for the hosted media.
     */
    url: string;
};
export namespace PropertyExternalMediaMatterportVirtualTourInput {
    /**
     * Virtual-tour media kind.
     */
    export enum kind {
        VIRTUAL_TOUR = 'VIRTUAL_TOUR',
    }
    /**
     * Matterport hosting provider.
     */
    export enum provider {
        MATTERPORT = 'MATTERPORT',
    }
}

